// schema
import * as ISchema from "#webapp/src/__schema__";
// libraries
import React from "react";

// components
import { TeamSections } from "../web-settings";

import { TeamSettingsAdminTeamCalendarWrapper } from "#webapp/src/components/teams-settings/team-settings-admin-form/team-settings-admin-team-calendar";
import { TrialProBadgeWithTooltip } from "@clockwise/web-commons/src/ui/trial-pro-badge-with-tooltip";

// material-ui
import { Link } from "@clockwise/design-system";
import { makeStyles } from "@material-ui/styles";
import { useMonetization } from "../../../hooks/useMonetization";
import { TeamSlack } from "./TeamSlack";

// ~-~-~-~-~-~-~-
// Team Availability Calendar Settings
// ~-~-~-~-~-~-~-
interface TeamAvailabilityCalendarProps {
  org: ISchema.IOrg;
  team: ISchema.ITeam;
}

const useStyles = makeStyles({
  content: {
    marginBottom: 30,
  },
});

export const TeamAvailabilityCalendar = (props: TeamAvailabilityCalendarProps) => {
  const classes = useStyles();
  const { getCopyForMonetizationBadges, daysLeftInTrial } = useMonetization();

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  const { org, team } = props;

  return (
    <>
      <div
        cw-id={`web-settings-${TeamSections.TeamAvailabilityCalendar}`}
        className={classes.content}
      >
        <div className="cw-flex cw-gap-2 cw-mb-6">
          <div className="cw-heading-xl">Team Availability Calendar</div>
          <TrialProBadgeWithTooltip
            tooltipType={getCopyForMonetizationBadges("Team Availability")}
            showToolTip={true}
            daysLeftOnTrial={daysLeftInTrial || undefined}
            badgeText="Teams"
            width={400}
          />
        </div>
        <div className="cw-body-lg cw-mb-6">
          Clockwise automatically syncs individual team member's “Out of office / unavailable”
          events to a shared team calendar to help the team stay informed about everyone's
          availability at a glance.{" "}
          <Link
            href="https://support.getclockwise.com/hc/en-us/articles/360041037012-Shared-Team-Calendars"
            target="_blank"
            rel="noreferrer"
          >
            Learn more
          </Link>
          .
        </div>
        <TeamSettingsAdminTeamCalendarWrapper org={org} team={team} />
      </div>
      <TeamSlack org={org} team={team} />
    </>
  );
};
